export interface AutocompleteSession {
  getToken: (
    createToken: () => google.maps.places.AutocompleteSessionToken,
  ) => google.maps.places.AutocompleteSessionToken;
  reset: () => void;
}

const createAutocompleteSession = (): AutocompleteSession => {
  let token: google.maps.places.AutocompleteSessionToken | undefined;

  return {
    getToken: (createToken) => {
      if (!token) {
        token = createToken();
      }

      return token;
    },
    reset: () => {
      token = undefined;
    },
  };
};

export default createAutocompleteSession;
